import memoize from 'lodash/memoize';

import { JWT } from '../types';
import { decodeToken } from './decodeToken';
import { getUserToken } from './getUserToken';

/**
 * Memoised on the raw token so repeated calls return a referentially stable object:
 * `useSyncExternalStore` re-renders in a loop if the snapshot changes identity on every read.
 *
 * The cache keeps one entry per token seen during the session, so it grows by one entry per
 * token refresh. That is a handful of entries even in a long-lived tab.
 */
const memoizedDecodeToken = memoize(decodeToken);

/** Returns the decoded form of the current user JWT. */
export const getDecodedUserToken = (): JWT | undefined => memoizedDecodeToken(getUserToken());
